import { taskPriorityMeta } from "@/lib/mockData";
import { cn } from "@/lib/utils";

export default function PriorityPill({ priority }) {
  const meta = taskPriorityMeta[priority] ?? taskPriorityMeta.low;
  return (
    <span
      data-testid={`priority-pill-${priority}`}
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-bold uppercase",
        meta.chip,
      )}
      style={{ letterSpacing: "0.14em" }}
    >
      {meta.label}
    </span>
  );
}
